/* eslint-disable @typescript-eslint/naming-convention */
export enum LanguageTagEnum {
    en_US = 'en-US',
    fr_CA = 'fr-CA',
    fr_FR = 'fr-FR',
    en_GB = 'en-GB'
}
